var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgFailureIcon = function SvgFailureIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41,
    height: 41,
    fill: "none",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D5D5D5",
    d: "M20.5 30.75q.87 0 1.462-.59.59-.59.588-1.46t-.59-1.46q-.59-.59-1.46-.59t-1.46.59q-.588.59-.59 1.46t.59 1.462a1.97 1.97 0 0 0 1.46.588m-2.05-8.2h4.1v-12.3h-4.1zM20.5 41q-4.253 0-7.995-1.615-3.741-1.616-6.509-4.381-2.767-2.765-4.38-6.509Q.001 24.752 0 20.5t1.615-7.995q1.618-3.744 4.381-6.509t6.509-4.38T20.5 0t7.995 1.615q3.745 1.616 6.509 4.381 2.763 2.765 4.383 6.509Q41.007 16.248 41 20.5q-.006 4.252-1.615 7.995-1.61 3.744-4.381 6.509-2.772 2.764-6.509 4.383Q24.758 41.004 20.5 41m0-4.1q6.867 0 11.634-4.766Q36.9 27.367 36.9 20.5T32.134 8.866Q27.367 4.1 20.5 4.1T8.866 8.866Q4.1 13.633 4.1 20.5t4.766 11.634T20.5 36.9"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgFailureIcon);
export default ForwardRef;